"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MISSING_ALT_TEXT_TEST_FLAG = exports.LABEL_WARNING_COLOR = exports.LABEL_ERROR_COLOR = exports.LABEL_ASTERISK_COLOR = exports.LABEL_ASTERISK_SPACING = exports.LABEL_SPACING = exports.LABEL_COLOR = exports.LABEL_SIZE = exports.DEFAULT_S_ICON_SIZE = exports.DEFAULT_ICON_SIZE = exports.DEFAULT_LINE_HEIGHT = exports.A11Y_INLINE_MIN_SIZE = exports.A11Y_MIN_SIZE = exports.A11Y_SIZE = exports.EM_TO_PX_RATIO = exports.EventKeys = void 0;
var EventKeys = {
  SPACEBAR: ' ',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  TAB: 'Tab',
  HOME: 'Home',
  END: 'End'
};
exports.EventKeys = EventKeys;
var EM_TO_PX_RATIO = 16; // Minimum accessible touch target sizes

exports.EM_TO_PX_RATIO = EM_TO_PX_RATIO;
var A11Y_SIZE = 44;
exports.A11Y_SIZE = A11Y_SIZE;
var A11Y_MIN_SIZE = 36;
exports.A11Y_MIN_SIZE = A11Y_MIN_SIZE;
var A11Y_INLINE_MIN_SIZE = 24; // Default sizes

exports.A11Y_INLINE_MIN_SIZE = A11Y_INLINE_MIN_SIZE;
var DEFAULT_LINE_HEIGHT = 1;
exports.DEFAULT_LINE_HEIGHT = DEFAULT_LINE_HEIGHT;
var DEFAULT_ICON_SIZE = 20;
exports.DEFAULT_ICON_SIZE = DEFAULT_ICON_SIZE;
var DEFAULT_S_ICON_SIZE = 16; // Constants for form elements

exports.DEFAULT_S_ICON_SIZE = DEFAULT_S_ICON_SIZE;
var LABEL_SIZE = 'T200';
exports.LABEL_SIZE = LABEL_SIZE;
var LABEL_COLOR = 'neutral90';
exports.LABEL_COLOR = LABEL_COLOR;
var LABEL_SPACING = 'S200';
exports.LABEL_SPACING = LABEL_SPACING;
var LABEL_ASTERISK_SPACING = 'S100';
exports.LABEL_ASTERISK_SPACING = LABEL_ASTERISK_SPACING;
var LABEL_ASTERISK_COLOR = 'neutral70';
exports.LABEL_ASTERISK_COLOR = LABEL_ASTERISK_COLOR;
var LABEL_ERROR_COLOR = 'red70';
exports.LABEL_ERROR_COLOR = LABEL_ERROR_COLOR;
var LABEL_WARNING_COLOR = 'yellow70'; // A11y

exports.LABEL_WARNING_COLOR = LABEL_WARNING_COLOR;
var MISSING_ALT_TEXT_TEST_FLAG = 'accessibility-missing-alt-text';
exports.MISSING_ALT_TEXT_TEST_FLAG = MISSING_ALT_TEXT_TEST_FLAG;